



































import Vue from 'vue';
import Component from 'vue-class-component';
import { InjectReactive, Prop } from 'vue-property-decorator';

// Shared types
import { IndoorUnitColor, OutdoorUnitColor, Color } from '@coldtec/cos-types';

// Tool types
import { Labels } from '@/types';

// Store types
import { ToolSystem, SystemUnitLocation, SystemSplit, ToolUnit, SpacesGetter } from '@/store/store.types';

/**
 *  Component to renders the unit of a selected system, including
 *  his color, SKU, possible space name and location label.
 */
@Component
export default class OverviewSystemUnit extends Vue {

    @Prop({ type: Object, required: true })
    private toolUnit!: ToolUnit;

    @InjectReactive('toolSystem')
    private toolSystem!: ToolSystem;

    /**
     *  Used to easily render the location label,
     *  based on the location of the unit.
     */
    private locationLabels: Labels = {
        [SystemUnitLocation.Outdoor]: 'Buitenunit',
        [SystemUnitLocation.Indoor]: 'Binnenunit',
    };

    /**
     *  Used to get the space for which the unit is rendered.
     */
    private get spaceName(): string | null {

        /**
         *  An outside unit doesn't have a space, and it's
         *  clear that an inside unit belongs to the
         *  single space for which the system is.
         */
        if (
            this.toolUnit.location === SystemUnitLocation.Outdoor ||
            this.toolSystem.split === SystemSplit.Single
        ) {

            return null;

        }

        const name = this.$store.getters[SpacesGetter.ADDED][this.toolUnit.toolSpaceId as string].data.name;

        return name.charAt(0).toUpperCase() + name.slice(1);

    }

    /**
     *  Used to get the selected color of the unit.
     */
    private get color(): Color | null {

        let color: Color | null = null;

        for (const unitColor of (this.toolUnit.data.colors || []) as Array<IndoorUnitColor | OutdoorUnitColor>) {

            if (unitColor.color.guid !== this.toolUnit.color) {

                continue;

            }

            color = unitColor.color;

        }

        return color;

    }

}
